import { render } from "./개인건강검진예약_완료.vue?vue&type=template&id=5c480ca5"
import script from "./개인건강검진예약_완료.vue?vue&type=script&lang=js"
export * from "./개인건강검진예약_완료.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__